/** API Core */
export const coreHomepagesCoreRoute = `virtual/homebuilder`;

/** API Corporate */
export const corporateHomepagesRoute = `homepages`;
export const corporateHomepagesByIdRoute = (homepageId: string) => `homepages/${homepageId}`;
